import { PureComponent } from 'react'
import { ReduxFormProps, OnSubmitReduxForm } from 'interfaces/component'
import { RedemptionStepNumber, RedemptionFormValues } from 'interfaces/bounty'
import AmountStep from 'components/features/pfm/RedemptionForm/AmountStep'
import SuccessStep from 'components/features/pfm/RedemptionForm/SuccessStep'
import ConfirmationStep from 'components/features/pfm/RedemptionForm/ConfirmationStep'
import AccountStep from 'components/features/pfm/RedemptionForm/AccountStep'
import { onFormSubmit } from 'helpers/formHelpers'
import { FormErrors } from 'redux-form'
import { REDEMPTION_AMOUNT_STEP_NUMBER, REDEMPTION_ACCOUNT_STEP_NUMBER, REDEMPTION_CONFIRM_STEP_NUMBER, REDEMPTION_SUCCESS_STEP_NUMBER } from 'constants/bounty'

export const redemptionFormFieldNames: Record<keyof RedemptionFormValues, string> = {
  amount: 'Amount',
  bank_account_type: 'Account Type',
  account_number: 'Account Number',
  routing_number: 'Routing Number',
  remember: 'Remember Checkbox',
  name: 'Account Nickname',
}

export type RedemptionFormStateProps = {
  rewardBalance: number
  minRedemptionAmount: number | null
  formValues: RedemptionFormValues
  initialValues: Partial<RedemptionFormValues>
  submitErrors: FormErrors<RedemptionFormValues>
}

export type RedemptionFormDispatchProps = {
  onStepChange: (stepNumber: RedemptionStepNumber) => void
}

export type RedemptionFormOwnProps = {
  stepNumber: RedemptionStepNumber
  onStepChange: (stepNumber: RedemptionStepNumber) => void
}

type RedemptionFormProps =
  & RedemptionFormStateProps
  & RedemptionFormDispatchProps
  & RedemptionFormOwnProps
  & ReduxFormProps<RedemptionFormValues>

class RedemptionForm extends PureComponent<RedemptionFormProps> {
  render () {
    const { minRedemptionAmount } = this.props
    if (typeof minRedemptionAmount !== 'number') {
      return null
    }

    const Step = this.getCurrentStep()
    if (!Step) {
      return null
    }

    return (
      <div>
        <Step
          { ...this.props }
          onSubmit={ this.handleSubmit }
        />
      </div>
    )
  }

  private getCurrentStep () {
    const { stepNumber } = this.props
    switch (stepNumber) {
      case REDEMPTION_AMOUNT_STEP_NUMBER: return AmountStep
      case REDEMPTION_ACCOUNT_STEP_NUMBER: return AccountStep
      case REDEMPTION_CONFIRM_STEP_NUMBER: return ConfirmationStep
      case REDEMPTION_SUCCESS_STEP_NUMBER: return SuccessStep
      default: return null
    }
  }

  private handleSubmit: OnSubmitReduxForm<RedemptionFormValues> = (values, dispatch, form) => {
    const { stepNumber } = this.props
    if (stepNumber === REDEMPTION_CONFIRM_STEP_NUMBER) {
      onFormSubmit(values, dispatch, form)
    } else {
      const nextStepNumber = (stepNumber + 1) as RedemptionStepNumber
      this.props.onStepChange(nextStepNumber)
    }
    return {}
  }
}

export default RedemptionForm
